import { useState } from "react";
import { Facebook, Twitter, MessageCircle, Link2, Check } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL || "";

export default function SocialShare({ url, title }) {
  const [copied, setCopied] = useState(false);

  const articleMatch = url.match(/\/artigo\/([a-f0-9-]+)/);
  const shareUrl = articleMatch
    ? `${API}/api/og/artigo/${articleMatch[1]}`
    : url;

  const fullUrl = url.startsWith("http") ? url : `${window.location.origin}${url}`;
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedTitle = encodeURIComponent(title);

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(fullUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      const input = document.createElement("input");
      input.value = fullUrl;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="flex items-center gap-3">
      <span className="text-zinc-500 text-sm">Compartilhar:</span>
      <button
        onClick={copyLink}
        className={`w-9 h-9 rounded-full flex items-center justify-center transition-all ${
          copied ? "bg-green-600" : "bg-white/10 hover:bg-white/20"
        }`}
        title={copied ? "Link copiado!" : "Copiar link"}
        data-testid="copy-link"
      >
        {copied ? <Check size={16} className="text-white" /> : <Link2 size={16} className="text-zinc-400" />}
      </button>
      <a
        href={`https://wa.me/?text=${encodedTitle}%20${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#25D366] flex items-center justify-center transition-all"
        data-testid="share-whatsapp"
        aria-label="Compartilhar no WhatsApp"
      >
        <MessageCircle size={16} className="text-zinc-400" />
      </a>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#1877F2] flex items-center justify-center transition-all"
        data-testid="share-facebook"
        aria-label="Compartilhar no Facebook"
      >
        <Facebook size={16} className="text-zinc-400" />
      </a>
      <a
        href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`}
        target="_blank"
        rel="noopener noreferrer"
        className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#1DA1F2] flex items-center justify-center transition-all"
        data-testid="share-twitter"
        aria-label="Compartilhar no Twitter"
      >
        <Twitter size={16} className="text-zinc-400" />
      </a>
    </div>
  );
}
